import React from 'react';
import { useContext } from 'react';
import { getConfiguration } from '../data/utils/configuration';
import { usePoll } from '../data/fetch/useFetch';
import { parseLiveInfo } from '../data/parseLiveInfo';
import { setLiveEventsNumber } from '../data/sport-utils';

export const LiveInfoContext = new React.createContext(null);

export function useLiveInfo() {
    return useContext(LiveInfoContext);
}

export default function LiveInfoProvider(props) {
    const conf = getConfiguration();

    const [, isError, data] = usePoll(conf.api.getLiveInfoForPrematch, null, (data =>
        parseLiveInfo(data)
    ));

    if (data) {
        setLiveEventsNumber(data.eventsCount);
    }

    return (
        <LiveInfoContext.Provider value={data}>
            {props.children}
        </LiveInfoContext.Provider>
    );
}
